import { useForm, Controller } from "react-hook-form";
import {
  FormLabel,
  FormControl,
  Input,
  Button,
  Text,
  Box,
  Wrap,
  WrapItem,
  Checkbox,
  VStack,
} from "@chakra-ui/react";
import emailjs from "emailjs-com";
import React from "react";

// Custom Emoji Radio Button (now toggleable)
function EmojiCheckbox({ value, isSelected, onToggle }) {
  return (
    <Box as="label">
      <Box
        as="button"
        type="button"
        onClick={() => onToggle(value)}
        cursor="pointer"
        fontSize="2xl"
        borderWidth="1px"
        borderRadius="md"
        boxShadow="md"
        bg={isSelected ? "teal.500" : "transparent"}
        color={isSelected ? "white" : "black"}
        borderColor={isSelected ? "teal.500" : "gray.200"}
        px={3}
        py={1}
        _hover={{ bg: "teal.100" }}
      >
        {value}
      </Box>
    </Box>
  );
}

export default function HookForm({ onSuccess }) {
  const {
    handleSubmit,
    register,
    control,
    formState: { errors, isSubmitting },
    reset,
    setValue,
    watch,
  } = useForm({
    defaultValues: {
      Mood: [],
      Solution: [],
    },
  });

  const moodOptions = ["😄", "🙂", "😟", "😢", "😭", "🥲", "🥺", "😠", "😡", "😤", "😾"];
  const solutionOptions = [
    "Hear a funny Ethan Cooper impression",
    "Get a hug from divij",
    "Seventeen binge session on zoom as soon as divij is back home",
    "CHOCOLATE",
    "Salty snackies",
    "Get spammed with insta reels",
    "Sleep on facetime together",
    "See a cute divij photo",
    "Receive a funny divij dancing video",
    "Nope they're all useless",
  ];

  const selectedMoods = watch("Mood");
  const selectedSolutions = watch("Solution");

  function toggleMood(emoji) {
    const updated = selectedMoods.includes(emoji)
      ? selectedMoods.filter((e) => e !== emoji)
      : [...selectedMoods, emoji];
    setValue("Mood", updated);
  }

  function toggleSolution(option) {
    const updated = selectedSolutions.includes(option)
      ? selectedSolutions.filter((o) => o !== option)
      : [...selectedSolutions, option];
    setValue("Solution", updated);
  }

  function onSubmit(values) {
    return emailjs
      .send(
        "service_hx1tb7z",
        "template_hi53ebi",
        {
          from_name: "Divij",
          from_email: "divijgarg04@gmail.com",
          message: JSON.stringify(values, null, 2),
        },
        process.env.REACT_APP_EMAILJS_USER
      )
      .then(() => {
        if (onSuccess) onSuccess();
        reset(); // clear form
      })
      .catch((error) => {
        console.error("Email send failed:", error);
      });
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)} style={{ display: "flex", justifyContent: "center" }}>
      <FormControl width="400px">
        {/* Bother Field */}
        <FormLabel htmlFor="Bother" mt={4}>
          What's bothering you?
        </FormLabel>
        <Input
          id="Bother"
          placeholder="Please explain what's bothering you!"
          {...register("Bother", { required: "This is required" })}
        />
        {errors.Bother && (
          <Text color="red.500" fontSize="sm" mt={1}>
            {errors.Bother.message}
          </Text>
        )}

        {/* Mood Emoji Multi-Select */}
        <FormLabel mt={4}>How are you feeling? (Select multiple)</FormLabel>
        <Wrap justify="center" spacing="12px" mt={2}>
          {moodOptions.map((emoji) => (
            <WrapItem key={emoji}>
              <EmojiCheckbox
                value={emoji}
                isSelected={selectedMoods.includes(emoji)}
                onToggle={toggleMood}
              />
            </WrapItem>
          ))}
        </Wrap>
        {selectedMoods.length === 0 && (
          <Text color="red.500" fontSize="sm" mt={1}>
            Please select at least one mood.
          </Text>
        )}

        {/* Solution Multi-Select */}
        <FormLabel mt={4}>Would any of these help? (Select multiple)</FormLabel>
        <VStack align="start" spacing={2}>
          {solutionOptions.map((option) => (
            <Checkbox
              key={option}
              isChecked={selectedSolutions.includes(option)}
              onChange={() => toggleSolution(option)}
            >
              {option}
            </Checkbox>
          ))}
        </VStack>
        {selectedSolutions.length === 0 && (
          <Text color="red.500" fontSize="sm" mt={1}>
            Please select at least one solution.
          </Text>
        )}

        {/* Submit Button */}
        <Button mt={6} colorScheme="teal" isLoading={isSubmitting} type="submit" width="100%">
          Send to divij
        </Button>
      </FormControl>
    </form>
  );
}
